export default __webpack_public_path__ + "static/media/pushpin.fb8e33ff.svg";